import { Attribute, Child, DomDirective, HostElement, CookieService } from './../../libs/core';

const BANNER_ID = 'calamiteiten-banner-id';
const MODIFIED_DATE = 'calamiteiten-banner-modified';
const IS_VISIBLE = 'is-visible';
const COOKIE_EXPIRE_TIME = 1; // number in days

/**
 *
 * @example
 * ```html
 * <article
        aa-calamiteiten-banner
        class="strip strip-calamiteiten-banner is-visible"
        data-id="12346"
        data-modified-date="12-12-2020"
    >
 * ```
 *
 */
@DomDirective({
  selector: 'aa-calamiteiten-banner',
})
export class CalamiteitenBannerDirective {
  /**
   * Reference to the HTMLElement this directive is applied on.
   *
   * @property {HTMLElement}
   */
  @HostElement()
  private readonly host: HTMLElement;

  @Child('.js-calamiteiten-banner-close')
  private readonly closeButton: HTMLElement;

  @Attribute('data-id')
  private bannerId: string;

  @Attribute('data-modified-date')
  private bannerModifiedDate: string;

  /**
   * Executed when directive is connected to the DOM element.
   */
  connected(): void {
    const cookieIdValue = CookieService.get(BANNER_ID);
    const cookieModifiedDate = CookieService.get(MODIFIED_DATE);

    if (
      cookieIdValue !== this.bannerId ||
      cookieModifiedDate !== this.bannerModifiedDate
    ) {
      this.host.classList.add(IS_VISIBLE);

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () =>
          this.handleButtonCloseClick(),
        );
      }
    }
  }

  private handleButtonCloseClick() {
    if (!this.bannerId && !this.bannerModifiedDate) {
      return;
    } else {
      CookieService.set(BANNER_ID, this.bannerId, COOKIE_EXPIRE_TIME, '/');
      CookieService.set(
        MODIFIED_DATE,
        this.bannerModifiedDate,
        COOKIE_EXPIRE_TIME,
        '/',
      );
      this.host.classList.remove(IS_VISIBLE);
    }
  }
}
